import { Injectable } from '@angular/core';
import { MonoTypeOperatorFunction, Observable, defer, finalize } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ErrorToastSuppressionService {
  private count = 0;

  get active(): boolean {
    return this.count > 0;
  }

  suppress<T>(): MonoTypeOperatorFunction<T> {
    return (source: Observable<T>) =>
      defer(() => {
        this.count++;
        return source.pipe(finalize(() => (this.count = Math.max(0, this.count - 1))));
      });
  }
}
